import { useState, useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom'

const STORAGE_KEY = 'checkup_cookie_consent'
const HIDDEN_PATHS = ['/privacy', '/terms']

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY)
    if (!accepted) {
      // Small delay so the slide-up animation is visible on first paint
      const timer = setTimeout(() => setVisible(true), 300)
      return () => clearTimeout(timer)
    }
  }, [])

  function handleAccept() {
    localStorage.setItem(STORAGE_KEY, 'accepted')
    setVisible(false)
  }

  function handleDecline() {
    localStorage.setItem(STORAGE_KEY, 'declined')
    setVisible(false)
  }

  // Never render on /privacy or /terms
  if (HIDDEN_PATHS.includes(location.pathname)) return null

  // Nothing to show if already accepted or not yet ready
  if (!visible) return null

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 flex justify-center px-4 pb-4 transition-transform duration-500 ease-out translate-y-0 animate-slideUp"
    >
      <div className="w-full max-w-2xl rounded-xl bg-white shadow-lg ring-1 ring-gray-200 p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <p className="text-sm text-gray-700 flex-1">
          We use essential cookies to keep you signed in and improve your experience. No tracking cookies are used.
        </p>

        <div className="flex items-center gap-2 shrink-0">
          <Link
            to="/privacy"
            className="text-sm font-medium text-teal-600 hover:text-teal-700 px-3 py-1.5 rounded-lg hover:bg-teal-50 transition-colors"
          >
            Learn More
          </Link>
          <button
            onClick={handleDecline}
            className="text-sm font-medium text-gray-600 hover:text-gray-800 bg-gray-100 hover:bg-gray-200 px-4 py-1.5 rounded-lg transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 px-4 py-1.5 rounded-lg transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
